import {
  isNativeCoin,
  getNativeTokenDecimal,
} from '@/composables/metamask/metamaskHelper';
import { ethers } from 'ethers';

const ERC20Abi = [
  'function balanceOf(address) view returns (uint)',
  'function decimals() view returns (uint)',
];

export default class UserCoinBalance {
  web3Provider;

  constructor(_web3Provider) {
    this.web3Provider = _web3Provider;
  }

  async getUserBalance(chainId, coin, tokenAddress, userAddress) {
    if (isNativeCoin(coin, parseInt(chainId, 16))) {
      const balance = await this.web3Provider.getBalance(userAddress);
      return ethers.utils.formatUnits(
        balance,
        getNativeTokenDecimal(parseInt(chainId, 16)),
      );
    }
    const ERC20Contract = new ethers.Contract(
      tokenAddress,
      ERC20Abi,
      this.web3Provider,
    );
    const [balance, decimal] = await Promise.all([
      ERC20Contract.balanceOf(userAddress),
      ERC20Contract.decimals(),
    ]);
    return ethers.utils.formatUnits(balance, decimal);
  }
}
